const emailRegex = new RegExp(/\S+@\S+\.\S+/);
const phoneRegex = new RegExp(/^[0-9 ()+-]+$/);
const ccardRegex = new RegExp(/^[0-9-]+$/);
const cvcRegex = new RegExp(/^[0-9]+$/);
const numbersRegex34 = new RegExp(/^.[0-9]{1,34}$/);

const notAllowSpcl = new RegExp(/^[A-Za-z0-9]+$/);
const notAllowSpclname = new RegExp(/^[A-Za-z0-9 ]+$/);

export const termsValidator = (value) => value ? "" : "Please accept terms & conditions of the application to proceed";
export const acntNameValidator = (value) => {
    if (!value) {
        return "Please enter name of the account holder of nominated bank."
    } else if (!notAllowSpclname.test(value)) {
        return "Please enter valid name of the account holder of nominated bank."
    } else if (value.length > 80) {
        return "Please enter vaild name of the account holder of nominated bank."
    }
}

//Personal info
export const nameValidator = (value) => {
    if (!value) {
        return "Please Enter Full Name as in your NRIC/Passport"
    } else if (!notAllowSpclname.test(value)) {
        return "Please Enter Full Name as in your NRIC/Passport"
    } else if (value.length > 80) {
        return "Please Enter Full Name as in your NRIC/Passport"
    }
}
export const nricValidator = (value) => {
    if (!value) {
        return "Please Enter your NRIC/Passport Number"
    }
    else if (value.length > 20) {
        return "Please Enter your NRIC/Passport Number"
    } else if (!notAllowSpcl.test(value)) {
        return "Please Enter your NRIC/Passport Number"
    }
}
export const countryValidator = (value) => value ? "" : "Please Select a Valid Country from the list";
export const IDTypeValidator = (value) => value ? "" : "Please Select a Valid ID Type from the list";

export const emailValidator = (value) => {
    if (value) {
        if (!emailRegex.test(value)) {
            return "Please Enter a Valid Email Address"
        } else if (value.length > 50) {
            return "Please Enter a Valid Email Address"
        }
    }
}


//Personal info
export const phoneValidator = (value) => !value ?
    "Phone number is required." :
    phoneRegex.test(value) || value < 8 ? "" : "Not a valid phone number.";

export const cardValidator1 = (value) => {
    if (!value) {
        return "Please enter a valid CreditAble account number"
    }
    if (value) {
        if (!ccardRegex.test(value)) {
            return "Please enter a valid CreditAble account number"
        } else if (value.substring(0, 5).trim() !== "04137" && value.substring(0, 5).trim() !== '04138') {
            return "Please enter a valid CreditAble account number."
        } else if (value.length !== 11) {
            return "Please enter a valid CreditAble account number"
        }
    }

}
export const cardValidator = (value) => !value ?
    "CreditAble account number is required. " :
    cvcRegex.test(value) && value.length !== 11 ? "" : "Not a valid credit card number format.";
export const CreditAbleValidator = (value) => !value ?
    "CreditAble account number is required. " :
    value.length !== 11 ? "Please Enter A Valid CreditAble Number" : "";
export const bankAcntValidator = (value) => !value ?
    "Credit card account number is required. " :
    ccardRegex.test(value) && value.length !== 16 ? "" : "Not a valid account number format.";
export const cradNAccountNumber = (value) => !value ?
    "Credit card / Account number is required. " :
    numbersRegex34.test(value) ? "" : "Not a valid credit card / account number format.";

export const cvcValidator = (value) => !value ?
    "CVC code is required," :
    cvcRegex.test(value) || value.length !== 3 ? "" : "Not a valid CVC code format.";
export const guestsValidator = (value) => !value ?
    "Number of items is required" :
    value < 5 ? "" : "Maximum 5 items";

export const nominatedbankVaild = (value) => value ? "" : "Please nominate a bank to receive the loan.";
export const bankAcntNOValidator = (value) => {
    if (!value) {
        return "Please enter credit card/line of credit/current or savings account number of nominated bank."
    }
    if (value) {
        if (!ccardRegex.test(value)) {
            return "Please enter credit card/line of credit/current or savings account number of nominated bank."
        } else if (value.length < 1) {
            return "Please enter credit card/line of credit/current or savings account number of nominated bank."
        } else if (value.length > 20) {
            return "Please enter credit card/line of credit/current or savings account number of nominated bank."
        }
    }
}

export const AmountValidator = (value) => {

    if (!value) {
        return "The amount transferred cannot be less than S$1000"
    } else if (!cvcRegex.test(value)) {
        return "Please enter numeric values for Loan Amount "
    } else if (value < 1000) {
        return "The amount transferred cannot be less than S$1000"
    }
    else if (parseInt(value) % 100 !== 0) {
        return "The loan amount must be multiple of 100"
    }
    else if (value > 10000000000) {
        return "The amount transferred cannot be more than S$1000K"
    }
}

export const tenureValidator = (value) => value ? "" : "Please select your preferred loan plan";


export const requiredValidator = (value) => value ? "" : "Error: This field is required.";
export const passwordValidator = (value) => value && value.length > 8 ? '' : 'Password must be at least 8 symbols.';
export const addressValidator = (value) => value ? "" : "Address is required.";

export const tovalidateExpdate = (value) => {
    let localExpTime = window.localStorage.getItem('expid');
    if (value > parseInt(localExpTime) + 9) {
        //alert("This session has timed out for your security.")
        return false

    } else {
        return true
        //nothing
    }
}